import router from '@/router'
import remoteConfig from '@/lib/remote-config'
import { quiz_enabled } from '@/lib/remote-config/constants'

import * as TYPES from './types'
import { GENERATE_RANDOM_QUIZ } from '../quiz/types'

export default {
  // changes the route based on the next question in the store for the current quiz
  [TYPES.NEXT_LESSON]({ getters, commit, dispatch }) {
    const currentTheme = getters.currentTheme
    const currentLessonStep = getters.currentLessonStep
    const currentLesson = getters.currentLesson

    const nextLessonId = getNextLessonId(currentLessonStep, currentLesson)

    if (!nextLessonId) {
      if (remoteConfig.getBoolean(quiz_enabled) && currentLessonStep.quizId) {
        dispatch(GENERATE_RANDOM_QUIZ, {
          contentType: 'lessonStep',
          contentId: currentLessonStep.id
        })

        return router.push({
          name: 'quiz',
          params: {
            contentId: currentLessonStep.id,
            quizId: currentLessonStep.quizId
          }
        })
      } else {
        return router.push({
          name: 'theme',
          params: {
            themeId: currentTheme.id
          }
        })
      }
    }

    // Change the progress
    commit(TYPES.SET_LESSON_STEP_PROGRESS, {
      lessonStepId: currentLessonStep.id,
      lessonId: nextLessonId
    })

    // change the route
    router.push({
      name: 'lesson',
      params: {
        themeId: currentTheme.id,
        lessonStepId: currentLessonStep.id,
        lessonId: nextLessonId
      }
    })
  },
  [TYPES.PREV_LESSON]({ getters }) {
    const currentTheme = getters.currentTheme
    const currentLessonStep = getters.currentLessonStep
    const currentLesson = getters.currentLesson

    const prevLessonId = getPrevLessonId(currentLessonStep, currentLesson)

    router.push({
      name: 'lesson',
      params: {
        themeId: currentTheme.id,
        lessonStepId: currentLessonStep.id,
        lessonId: prevLessonId
      }
    })
  }
}

function getNextLessonId(currentLessonStep, currentLesson) {
  // if the lesson step is not started yet, take the first
  if (!currentLesson) {
    return currentLessonStep.lessons[0]
  }

  const currentLessonId = currentLesson.id
  const numberOfLessons = currentLessonStep.lessons.length

  // if it was the last lesson, return null
  if (currentLessonStep.lessons.indexOf(currentLessonId) + 1 === numberOfLessons) {
    return null
  }

  // default
  const nextLessonIndex = currentLessonStep.lessons.indexOf(currentLessonId) + 1
  return currentLessonStep.lessons[nextLessonIndex]
}

function getPrevLessonId(curentLessonStep, currentLesson) {
  const currentLessonIndex = curentLessonStep.lessons.findIndex(
    lessonId => lessonId === currentLesson.id
  )

  if (!currentLessonIndex) return null

  return curentLessonStep.lessons[currentLessonIndex - 1]
}
